import Repository from '../Repository'

const resource = '/a/nport'
export default {
    fetch(){
        return Repository.get(`${resource}`) 
    },
    
}